import createIcon from '../../createIcon';

/**
 * @component @name BorderClear
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyA1SDlWM0g3VjVaTTcgMTNIOVYxMUg3VjEzWk03IDIxSDlWMTlIN1YyMVpNMTEgMTdIMTNWMTVIMTFWMTdaTTExIDIxSDEzVjE5SDExVjIxWk0zIDIxSDVWMTlIM1YyMVpNMyAxN0g1VjE1SDNWMTdaTTMgMTNINVYxMUgzVjEzWk0zIDlINVY3SDNWOVpNMyA1SDVWM0gzVjVaTTExIDEzSDEzVjExSDExVjEzWk0xOSAxN0gyMVYxNUgxOVYxN1pNMTkgMTNIMjFWMTFIMTlWMTNaTTE5IDIxSDIxVjE5SDE5VjIxWk0xOSA5SDIxVjdIMTlWOVpNMTEgOUgxM1Y3SDExVjlaTTE5IDNWNUgyMVYzSDE5Wk0xMSA1SDEzVjNIMTFWNVpNMTUgMjFIMTdWMTlIMTVWMjFaTTE1IDEzSDE3VjExSDE1VjEzWk0xNSA1SDE3VjNIMTVWNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BorderClear = createIcon('BorderClear', [
  [
    'path',
    {
      d: 'M7 5H9V3H7V5ZM7 13H9V11H7V13ZM7 21H9V19H7V21ZM11 17H13V15H11V17ZM11 21H13V19H11V21ZM3 21H5V19H3V21ZM3 17H5V15H3V17ZM3 13H5V11H3V13ZM3 9H5V7H3V9ZM3 5H5V3H3V5ZM11 13H13V11H11V13ZM19 17H21V15H19V17ZM19 13H21V11H19V13ZM19 21H21V19H19V21ZM19 9H21V7H19V9ZM11 9H13V7H11V9ZM19 3V5H21V3H19ZM11 5H13V3H11V5ZM15 21H17V19H15V21ZM15 13H17V11H15V13ZM15 5H17V3H15V5Z',
      key: '10hudx',
    },
  ],
]);

export default BorderClear;
